import { map } from 'obliterator';

import type { AnyCaliperObject } from './caliper-utils';
import { parseSelectedObjects } from './load-utils';
import type { RendererState } from './renderer';

export type UpdateSelectedObjectsPayload = {
  selectedObjects?: AnyCaliperObject[];
  historicalSelectedObjects?: AnyCaliperObject[];
  caliperToolSelections?: AnyCaliperObject[];
  caliperObjects?: AnyCaliperObject[];
  historicalCaliperObjects?: AnyCaliperObject[];
};

export const handleUpdateSelectedObjectEntities = (
  thisState: RendererState,
  nextState: RendererState,
): void => {
  const { bodyOrAssemblyInstanceById } = nextState;

  let shouldUpdate = false;
  const updatePayload: UpdateSelectedObjectsPayload = {};

  // handle selected objects for selector tool
  if (nextState.selectorToolSelections !== thisState.selectorToolSelections) {
    const nextSelectedObjects = parseSelectedObjects(
      //pass IterableIterator rather than doing nextState.selectorToolSelections.map and
      //then passing result so parseSelectedObjects only interates once
      map(
        nextState.selectorToolSelections,
        ({ selectedObject }) => selectedObject,
      ),
      bodyOrAssemblyInstanceById,
    );
    shouldUpdate = true;
    updatePayload.selectedObjects = nextSelectedObjects;
  }

  // handle historical selected objects
  if (nextState.selectedObjectsKeys !== thisState.selectedObjectsKeys) {
    const nextSelectedObjects = parseSelectedObjects(
      nextState.selectedObjectsKeys,
      bodyOrAssemblyInstanceById,
    );
    shouldUpdate = true;
    updatePayload.historicalSelectedObjects = nextSelectedObjects;
  }

  // handle caliper objects for measurement tool
  if (nextState.caliperToolSelections !== thisState.caliperToolSelections) {
    const nextCaliperObjects = parseSelectedObjects(
      nextState.caliperToolSelections,
      bodyOrAssemblyInstanceById,
    );
    shouldUpdate = true;
    updatePayload.caliperObjects = nextCaliperObjects;
  }

  // handle historical caliper objects
  if (nextState.caliperObjectsKeys !== thisState.caliperObjectsKeys) {
    const nextCaliperObjects = parseSelectedObjects(
      nextState.caliperObjectsKeys,
      bodyOrAssemblyInstanceById,
    );
    shouldUpdate = true;
    updatePayload.historicalCaliperObjects = nextCaliperObjects;
  }

  if (shouldUpdate) {
    thisState.onUpdateSelectionEntities(updatePayload);
  }
};
